import { EventEmitter } from "events";

export const EventsTypes = {
  DESOBFUSCATION_DONE: "custom-events/desobfuscation-done",
  MQ_STATE: "custom-events/mq-change",
  ADSERVER_LOADED: "custom-events/adserver-loaded",
  MENU_OPEN: "custom-events/menu-open",
  MENU_CLOSE: "custom-events/menu-close",
  SEARCH_OPEN: "custom-events/search-open",
  SEARCH_CLOSE: "custom-events/search-close",
  OVERLAY_CLICK: "custom-events/overlay-click",
  // The roller emitted this after scrolling with the key missing, so `emit(undefined)`.
  // The value is the name allocine and le10sport listen on in their own emitters.
  LAZY_REVALIDATE: "custom-events/lazy-revalidate",
};

const eventEmitter = new EventEmitter();

export default eventEmitter;
